module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0050.jpg?v=8c99c5fa";